import React, { useState } from "react";
import TaxForm from "./TaxForm";
import { createTax } from "../../api/TaxService";

export default function AddTax() {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (formData) => {
    setLoading(true);

    try {
      const res = await createTax(formData);
      return res;
    } catch (err) {
      return err?.response?.data;
    } finally {
      setLoading(false);
    }
  };

  return (
    <TaxForm
      onSubmit={handleSubmit}
      loading={loading}
      isEdit={false}
    />
  );
}